/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CreateTicketStatusDto } from '../../models/create-ticket-status-dto';
import { TicketStatusResponseItem } from '../../models/ticket-status-response-item';

export interface TicketStatusControllerCreate$Params {
      body: CreateTicketStatusDto
}

export function ticketStatusControllerCreate(http: HttpClient, rootUrl: string, params: TicketStatusControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketStatusResponseItem;
}>> {
  const rb = new RequestBuilder(rootUrl, ticketStatusControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TicketStatusResponseItem;
      }>;
    })
  );
}

ticketStatusControllerCreate.PATH = '/ticket-status';
